<template>
  <v-container class="deals-list">
    <selected-modal :shown="isSelectedModal" :count="selectedCount" @hide="hideModal" />
    <div>
      <div class="list-header" v-if="!extended">
        <h3>Illustrative examples of live deals</h3>
        Deals added weekly
      </div>
      <div class="list-header" v-if="extended">
        <h3>Opportunities available in Africa</h3>
        <p style="font-size: 75%">
          Review deals and register your interest to receive additional information via follow up email
        </p>
        <div class="actions">
          <span>
            <a @click.stop="showFilters = true">
              <v-icon medium color="#fff">mdi-filter-variant</v-icon>
              <span>Deals Preferences</span>
            </a>
          </span>
          <span>
            <router-link to="/my-deals">
              <v-icon medium color="#fff">mdi-briefcase-check-outline</v-icon>
              <span>Selected Deals</span>
            </router-link>
            <span class="badge" v-if="registered">{{ registered }}</span>
          </span>
          <div class="count" v-if="pagination.total">
            {{ hits }} out of {{ pagination.total }} deals shown
          </div>
        </div>
      </div>
    </div>

    <filters :show="showFilters" @close="showFilters = false" />

    <div class="deals-wrap" :style="extended ? 'margin: 120px 0 80px' : ''">
      <deal-item
        v-for="deal in deals"
        :key="deal._id"
        :deal="deal"
        :extended="extended"
        :selected="selectedDeals.includes(deal._id)"
        :active="extended"
        @select="handleSelect"
      />
      <v-col cols="12" align="center" justify="center" v-if="!deals.length">
        <div class="nodeals">
          There are no deals matching your preferences.
        </div>
      </v-col>
      <v-row v-if="extended && (hits || 0) > 10">
        <v-col cols="auto">
          <div style="width: 50px"></div>
        </v-col>
        <v-col cols="11" align="left" class="pagination" v-if="hits > 10">
          <a class="back" @click="backward">&gt;</a>
          <div class="page">
            <label>Page</label>
            <div class="numbers">{{ (pagination.page || 0) + 1 }} of {{ Math.ceil(hits / 10) }}</div>
          </div>
          <a class="forward" @click="forward">&lt;</a>
        </v-col>
      </v-row>
    </div>
    <div id="register" v-if="extended && selected.length">
      <v-row v-if="completed">
        <v-col cols="12" align="center" justify="center">
          <div class="deal-checkbox">
            <label>
              {{ selected.length }} deal{{ selected.length > 1 ? 's' : '' }} added. We'll be in touch shortly
            </label>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!completed">
        <v-col cols="6" align="center" justify="center">
          <div class="deal-checkbox">
            <input type="checkbox" :checked="true" @change="false" disabled  />
            <label>
              {{ selected.length }} deal{{ selected.length > 1 ? 's' : '' }} selected
            </label>
          </div>
        </v-col>
        <v-col cols="auto">
          <v-btn x-large color="#f0b323" @click="register">
            Register your interest
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash'
import DealItem from './item'
import dealsData from '@/data/deals'
import Filters from './filters'
import SelectedModal from './modals/selected-modal'

export default {
  name: 'deals-list',
  components: {
    DealItem,
    Filters,
    SelectedModal
  },
  props: {
    extended: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loggedIn: false,
      completed: false,
      selectedDeals: [],
      showFilters: false,
      isSelectedModal: false,
      selectedCount: 0
    }
  },
  computed: {
    selected () {
      return this.selectedDeals
    },
    registered () {
      return (this.interest.deals || []).filter(d => !d.archivedAt).length
    },
    currentUser () {
      return this.$store.getters['user/currentUser']
    },
    interest () {
      return this.$store.getters['deals/interest'] || {}
    },
    deals () {
      return this.$store.getters['deals/list'] || dealsData
    },
    hits () {
      const hits = this.$store.getters['deals/hits']
      return (hits || hits === 0) ? hits : dealsData.length
    },
    filters () {
      return this.$store.getters['deals/filters']
    },
    pagination () {
      return this.$store.getters['deals/pagination'] || {
        total: null
      }
    }
  },
  methods: {
    handleSelect (id) {
      if (this.selectedDeals.includes(id)) {
        this.selectedDeals = this.selectedDeals.filter(item => item !== id)
      } else {
        this.selectedDeals = this.selectedDeals.concat(id)
      }
    },
    register () {
      const selected = this.deals.filter(d => this.selectedDeals.includes(d._id)).map(d => {
        d.addedAt = d.addedAt || Date.now()
        return d
      })

      this.interest.deals = _.uniqBy((this.interest.deals || []).concat(selected), '_id')
      return this.$store.dispatch('deals/update', { interest: this.interest }).then((interest) => {
        this.completed = true
        this.selectedCount = this.selectedDeals.length
        this.selectedDeals = []
        this.isSelectedModal = true
        this.$store.dispatch('deals/total', null, { root: true })
        return this.$store.dispatch('deals/list').then(() => {
          setTimeout(() => {
            this.completed = false
          }, 3000)
        })
      }).catch((err) => {
        this.$log(err)
      })
    },
    forward () {
      const page = (this.pagination.page || 0) + 1
      if (page < Math.ceil(this.pagination.total / 10)) {
        this.pagination.page = page
        return this.$store.dispatch('deals/list')
      }
    },
    backward () {
      const page = this.pagination.page - 1
      if (page >= 0) {
        this.pagination.page = page
        return this.$store.dispatch('deals/list')
      }
    },
    hideModal () {
      this.isSelectedModal = false
      this.selectedCount = 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
.deals-list {
  box-shadow: 0px 0px 14px rgba(59, 73, 86, 0.15);
  border-radius: 6px;
  position: relative;
  padding: 120px 0 0 0;
  #register {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 86px;
    background: rgba(255, 245, 215, 0.9);
    backdrop-filter: blur(8px);
    z-index: 100500;
    .deal-checkbox {
      input[type='checkbox'] {
        width:25px;
        height:25px;
        background:white;
        border-radius:5px;
        border:2px solid #555;
        margin-top: 5px;
        float: 'left';
      }
      input[type='checkbox']:checked {
        background: #18305A;
      }
    }
    label {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 130%;
      align-items: center;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #626262;
      height: 100%;
      top: -5px;
      position: relative;
      margin: 0 0 0 10px;
    }
  }
  .pagination {
    padding: 50px 15px;
    .back, .forward {
      display: block;
      width: 56px;
      height: 56px;
      float: left;
      background: #18305A;
      transform: matrix(-1, 0, 0, 1, 0, 0);
      color: white;
      align: center;
      text-align: center;
      line-height: 56px;
      font-weight: bold;
    }
    .page {
      float: left;
      background: #EBF5FF;
      height: 56px;
      padding: 15px;
      label {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 130%;
        display: flex;
        align-items: center;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #93979D;
      }
      .numbers {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 130%;
        display: flex;
        align-items: center;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #18305A;
      }
    }
  }
}
.list-header {
  position: absolute;
  top: -30px;
  left: 0px;
  width: 100%;
  padding: 30px;
  font-size: 20px;
  font-family: $header-font;
  color: #fff;
  background: #002f6c;
  @media (min-width: 800px) {
    font-size: 36px;
  }
  .actions {
    span {
      margin-right: 20px;
      display: inline-flex;
      align-items: center;
    }
    a {
      display: inline-flex;
      align-items: center;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 130%;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: #fff;
      text-decoration: none;
      i {
        margin-right: 5px;
      }
      span {
        text-decoration-line: underline;
        margin: 0px;
      }
    }
    .badge {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: #fff;
      border-radius: 30px;
      margin-left: 5px;

      font-style: normal;
      font-size: 14px;
      font-weight: bold;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0.06em;
      color: #002f6c;
    }
    .count {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      margin: 0 0 0 30px;
    }
  }
}
.deals-wrap {
  :last-child {
    box-shadow: none!important;
  }
  max-width: none !important;
  padding: 0;
  position: relative;
  overflow: hidden;
}
.nodeals {
  font-family: $header-font;
  color: $text-primary;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  margin-bottom: 20px;
  padding: 100px 0px 50px;
}

</style>
